<template>
    <v-container>
        <v-row align="center" justify="center">
            <v-col cols="6" class="text-start" v-if="brand">
               
                        <v-btn 
                            class="btn-primelinks "    
                            variant="plain" 
                            :to="brand.route">
                            
                            <v-img 
                                v-if="brand.logo_white"
                                :lazy-src="brand.logo_white.sizes.thumbnail"
                                lazy
                                contain
                                class="mx-auto"
                                height="30px"
                                width="30px"
                                :alt="brand.title+' - '+brand.description"
                                :src="brand.logo_white.sizes.full"
                            ></v-img>
                           <span class="nobr d-none"> {{ brand.title }} </span>
                        </v-btn>
                   
            </v-col>
            <v-col cols="6" class="text-end" v-if="type">
              
                            <v-btn 
                                class="btn-primelinks"    
                            variant="plain" 
                                :to="type.route">
                                <span class="nobr"> {{ type.title }} </span>
                                <v-img 
                                    v-if="type.logo_white"
                                    :lazy-src="type.logo_white.sizes.thumbnail"
                                    lazy
                                    cover
                                    class="ms-3"
                                    height="30px"
                                    width="50px"
                                    :alt="type.title+' - '+type.description"
                                    :src="type.logo_white.sizes.full"
                                >
                                </v-img>
                            </v-btn>
                      
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import {mapGetters} from "vuex";
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            single: 'pages/single',
            adminSingle: 'AdminPages/single',
        })
    },
    data: () => ({
        brand: null,
        type: null,
    }),
    mounted(){
        if(!this.single){
            this.brand = this.adminSingle.brand;
            this.type = this.adminSingle.type;
        }else{
            this.brand = this.single.brand;
            this.type = this.single.type;
        }
    }
}
</script>